import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Menu as MenuIcon, Search, Notifications } from '@mui/icons-material';
import { useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';

export { HomeBar };

function HomeBar({ onSidebarToggle, onBrandClick }) {
  const authUser = useSelector(state => state.auth.user);
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Only show HomeBar on Home page
  const isHomePage = location.pathname === '/';

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    // TODO: Implement search functionality
    console.log('Search query:', searchQuery);
  };

  // Don't render HomeBar if not authenticated or not on home page
  if (!authUser || !isHomePage) return null;

  return (
    <AppBar 
      position="static" 
      sx={{ 
        width: '100%',
        zIndex: 1100
      }}
    >
      <Toolbar>
        {/* Brand name - clickable on mobile */}
        {isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <IconButton
              color="inherit"
              aria-label="toggle menu"
              onClick={onSidebarToggle}
              edge="start"
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              onClick={onBrandClick}
              sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8
                }
              }}
            >
              TilBuzz
            </Typography>
          </Box>
        )}

        {/* Search Box - Left aligned, extends to middle */}
        <Box 
          component="form" 
          onSubmit={handleSearchSubmit}
          sx={{ 
            flexGrow: 1, 
            maxWidth: { xs: '100%', md: '50%' },
            mr: 2
          }}
        >
          <TextField
            placeholder="Search content..."
            value={searchQuery}
            onChange={handleSearchChange}
            size="small"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                borderRadius: 2,
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.8)',
                },
                '& input': {
                  color: 'white',
                  '&::placeholder': {
                    color: 'rgba(255, 255, 255, 0.7)',
                    opacity: 1,
                  },
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ color: 'rgba(255, 255, 255, 0.7)' }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {/* Right side - Notifications only */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Notifications */}
          <IconButton color="inherit">
            <Notifications />
          </IconButton>

          {/* Username - hidden on mobile */}
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'white', 
              fontWeight: 500,
              display: { xs: 'none', sm: 'block' }
            }}
          >
            {authUser.name}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}